module.exports = __webpack_public_path__ + "static/img/jiayin-benefit.6ff0a2a8.png";